import type { VisioLink } from '@gozoki/api-types'
import { useMutation } from '@tanstack/react-query'
import { fetchAskVisio } from '../queries/visio.queries'

interface AskVisioVariables {
  kioskId: number
  includeVideo: boolean
  openingEventId?: number
  signal?: AbortSignal
}

export const useAskVisio = () =>
  useMutation<VisioLink, Error, AskVisioVariables>({
    mutationFn: ({ kioskId, includeVideo, openingEventId, signal }) =>
      fetchAskVisio(kioskId, includeVideo, openingEventId, signal),
  })
